import { IconButton, InputBase, makeStyles, Paper } from "@material-ui/core";
import { useEffect, useState } from "react";

import SearchIcon from "@material-ui/icons/Search";
import { useIntl } from "react-intl";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    width: "100%",
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
}));

export const SearchV2Component = ({data, fields, setData}) => {
  /**
   * States here
   */
  const [query, setQuery] = useState("");
  const classes = useStyles();
  const intl = useIntl();

  /**
   * Methods here
   */
  const handleChange = (event) => {
    const value = event.target.value.toLowerCase();
    setQuery(value);

    const filteredData = data.filter((item) =>
      fields.some((field) => item[field]?.toString().toLowerCase().includes(value))
    );

    setData(filteredData);
  };

  /**
   * UseEffect here
   */
  useEffect(() => {

  }, []);
  return (
    <Paper className={classes.root}>
      <InputBase
        className={classes.input}
        placeholder={`${intl.formatMessage({ id: "Search" })} ...`}
        inputProps={{ "aria-label": "search" }}
        value={query}
        onChange={handleChange}
      />
      <IconButton className={classes.iconButton} aria-label="search" onClick={handleChange}>
        <SearchIcon />
      </IconButton>
    </Paper>
  );
};